import {ACTION_CATEGORY, ANALYTICS_MODULE} from 'analytics/AnalyticsTypes';

// Keep in sync with benchling/analytics/lib/worklists_analytics_event.py
export const WORKLISTS_ANALYTICS_ACTIONS = {
  // READ actions
  FILLED_FROM_WORKLIST: {
    module: ANALYTICS_MODULE.WORKLISTS,
    action: 'filled_from_worklist',
    actionCategory: ACTION_CATEGORY.READ,
  },
  OPENED_SETTINGS_MODAL: {
    module: ANALYTICS_MODULE.WORKLISTS,
    action: 'opened_settings_modal',
    actionCategory: ACTION_CATEGORY.READ,
  },
};
